import React from "react";
import { ErrorAlert, Rating, SaveButton, TextArea } from "../common/Forms";
import { CheckboxInputGroup, RadioInputGroup } from "./SurveyComponents";

const SurveyForm = ({
  id,
  title,
  contents,
  error,
  list,
  responses,
  handleChange,
  handleSave,
  btnDisabled,
}) => {
  const onTextRatingChange = (i) => (e) => {
    handleChange(i, e.target.value);
  };
  const onChange = (i, v) => {
    handleChange(i, v);
  };
  return (
    <div className="container mx-auto lg:my-8 lg:max-w-screen-lg">
      <div className="lg:rounded-t-3xl bg-cyan-500 px-6 py-4 md:px-10 md:py-8">
        <h1 className="break-keep md:text-5xl text-3xl leading-tight text-white font-bold">
          {title}
        </h1>
        <h3 className="mt-6 break-keep text-white">
          {contents.map((v, i) => (
            <p key={`content_${id}_${i}`}>{v}</p>
          ))}
        </h3>
      </div>
      <div className="md:rounded-b-3xl border-t border-zinc-200 bg-white md:p-8 shadow">
        {error && <ErrorAlert>{error}</ErrorAlert>}
        {list.length > 0 && (
          <>
            <div className="text-black px-2">
              <span className="mr-1 ordinal text-red-600">*</span>필수
            </div>
            <ol className="my-4 ml-6 sm:ml-10 list-decimal">
              {list.map(({ q, option }, i) => (
                <li className="mb-8 font-semibold text-black" key={`q_${i}`}>
                  {q.content &&
                    q.content.map((v, j) => (
                      <div key={`q_sentence_${j}`}>
                        <span className={j > 0 ? "block" : ""}>{v}</span>
                        {j === 0 && q.required && (
                          <span className="ordinal text-red-600"> *</span>
                        )}
                      </div>
                    ))}

                  <div className="mt-4 ml-4 space-y-4">
                    {(q.type === "text" || q.type === "textarea") && (
                      <TextArea
                        name={`q_${i}_options`}
                        placeholder={option[0].content || "답변을 입력하세요."}
                        className="w-3/5 p-1 max-md:w-1/2 max-sm:mr-12 max-sm:w-full"
                        value={responses[i] || ""}
                        onChange={onTextRatingChange(i)}
                      />
                    )}
                    {q.type === "rating" && (
                      <Rating
                        {...{
                          length: 10,
                          value: responses[i] || 0,
                          id: `${q.type}-${i}`,
                          onChange: onTextRatingChange(i),
                        }}
                      />
                    )}
                    {q.type === "radio" && (
                      <RadioInputGroup
                        {...{
                          option,
                          index: i,
                          value: responses[i],
                          onChange,
                        }}
                      />
                    )}
                    {q.type === "checkbox" && (
                      <CheckboxInputGroup
                        {...{
                          option,
                          index: i,
                          value: responses[i],
                          onChange,
                        }}
                      />
                    )}
                  </div>
                </li>
              ))}
            </ol>
            <SaveButton onClick={handleSave} disabled={btnDisabled}>
              제출
            </SaveButton>
          </>
        )}
      </div>
    </div>
  );
};

export default SurveyForm;
